import { cloneDeep } from 'lodash';
import { useMutation } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { orderListQuery } from 'queries/OrderList';
import {
  ArchiveOrderIdeaMutation as Mutation,
  ArchiveOrderIdeaMutationVariables as Variables,
} from './__generated__/ArchiveOrderIdeaMutation';
import { OrderListQuery } from 'queries/OrderList/__generated__/OrderListQuery';
import * as mutation from './mutation.gql';
import { Investment_IdeaType } from 'types/common';

const updateOrderList = (orderId: number) => (store: DataProxy) => {
  const query = orderListQuery({ archived: false });
  const data = store.readQuery<OrderListQuery>(query);
  if (!data) {
    return;
  }

  const newData = cloneDeep(data);

  newData.lab.buyOrders.list = data.lab.buyOrders.list.filter(
    (order) => !(order.__typename === 'Investment_BuyOrder' && order.id === orderId)
  );

  store.writeQuery<OrderListQuery>({ ...query, data: newData });
};

export const useIdeaOrderArchive = (id: number, ideaType: Investment_IdeaType) => {
  const [archive, { loading, error }] = useMutation<Mutation, Variables>(mutation, {
    variables: {
      id,
      ideaType,
    },
    refetchQueries: [orderListQuery({ archived: true })],
    update: updateOrderList(id),
  });

  return {
    archive: () => archive(),
    loading,
    error,
  };
};
